import {APP_KEY} from "shared/constants";

const rehydrateStore = () => {
    if (localStorage.getItem(APP_KEY) !== null)
        return JSON.parse(localStorage.getItem(APP_KEY));
};

export {rehydrateStore};
